import { cx } from "shared/utils";
import {
  type BannerButtonGroupPosition,
  type BannerVariant,
  type ButtonProps
} from "../utils";
import { BannerButton } from "./BannerButton";

export type BannerButtonGroupProps = {
  variant: BannerVariant;
  buttonGroupPosition?: BannerButtonGroupPosition;
  primaryButton?: ButtonProps;
  secondaryButton?: ButtonProps;
  className?: string;
};

export const BannerButtonGroup = ({
  variant,
  buttonGroupPosition = "right",
  primaryButton,
  secondaryButton,
  className
}: BannerButtonGroupProps) => {
  const isButtonsRight = buttonGroupPosition === "right";
  const twoButtonsAtBottom =
    buttonGroupPosition === "bottom" && !!primaryButton && !!secondaryButton;

  return (
    <div
      className={cx(
        "flex flex-wrap items-center gap-2",
        !isButtonsRight && "pt-3",
        isButtonsRight && "shrink-0 justify-end",
        className
      )}
    >
      {/* Order: secondary (left/grey when two at bottom), then primary (right/colored). */}
      <BannerButton
        button={secondaryButton}
        variant={variant}
        buttonGroupPosition={buttonGroupPosition}
        greyTextWhenBottom={twoButtonsAtBottom}
      />
      <BannerButton
        button={primaryButton}
        variant={variant}
        buttonGroupPosition={buttonGroupPosition}
        greyTextWhenBottom={false}
      />
    </div>
  );
};
